import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			En praaj tempoj oni ŝatis sidadi ĉe fenestro; sed nun ili plejofte sidas antaŭ la televidilo.
		</p>
		
		<p class="mb-3">
			Verdire, la televidilo montras pli multe: oni povas ne nur la propran straton, sed eĉ diversajn landojn ekvidi. 
			Sed la fenestro logas promeni, ekspiri la freŝan aeron, kaj la televidilo preferas, ke ĉiuj sidu hejme. 
			Antaŭ la televidilo.
		</p>
		
		<p class="mb-3">
			Do ĉiuj sidas, kaj ĝi montras, kiel tie, en foraj lokoj, aliuj homoj promenas, freŝan aeron spiras. 
			Tiuj, kiuj spiras la freŝan aeron, havas tiel bonan koloron de vizaĝo!
		</p>
		
		<p class="mb-3">
			Precipe en la bona kolora televidilo.
		</p>
		`
	)
}

const itemName = {
	esp: 'Fenestro al al mondo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;